import List from './list.vue';
import RichList from './rich-list.vue';
import CardList from './card-list.vue';

export { List, RichList, CardList };
export default List;
